import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import PageHeading from "../../components/common/PageHeading";
import reportImage from "../../assets/images/life-journey/report-book.jpg";
import lifeChangingReportImage from "../../assets/images/life-changing/report-book.jpg";
import kundaliMatchingReportImage from "../../assets/images/kundali-matching/report-book.jpg";
import loveReportImage from "../../assets/images/love-report/report-book.jpg";
import komboReportImage from "../../assets/images/combo-report/diwalicomboffer.webp";

// Data for the report cards
const reportsData = [
  {
    title: "Life Journey Report",
    imageUrl: reportImage,
    link: "/life-journey-report",
  },
  {
    title: "Life Changing Report",
    imageUrl: lifeChangingReportImage,
    link: "/life-changing-report",
  },
  {
    title: "Kundali Matching Report",
    imageUrl: kundaliMatchingReportImage,
    link: "/kundali-matching-report",
  },
  {
    title: "Love Report",
    imageUrl: loveReportImage,
    link: "/love-report",
  },
  {
    title: "Combo Report",
    imageUrl: komboReportImage,
    link: "/navratri-report",
  },
];

// Reusable card component for displaying a report
const ReportCard = ({ title, imageUrl, link }) => (
  <Link to={link} className="block group">
    <div className="bg-white rounded-lg shadow-md overflow-hidden transform group-hover:scale-105 group-hover:shadow-xl transition-all duration-300 ease-in-out cursor-pointer h-full flex flex-col">
      <img src={imageUrl} alt={title} className="w-full object-cover" />
      <div className="p-4 flex-grow flex items-center justify-center">
        <h3 className="text-lg font-semibold text-center text-gray-800">{title}</h3>
      </div>
    </div>
  </Link>
);

// The main Reports page component
const Reports = () => {
  return (
    <>
      <Header />
      <main className="bg-gray-50 min-h-screen">
        <PageHeading
          title="Our Reports"
          breadcrumb={[{ name: "Home", path: "/" }, { name: "Reports" }]}
        />
        <section className="py-12 md:py-16">
          <div className="container mx-auto px-4 py-12">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {reportsData.map((report, index) => (
                <ReportCard
                  key={index}
                  title={report.title}
                  imageUrl={report.imageUrl}
                  link={report.link}
                />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Reports;
